import { CSSProperties, FC } from 'react';

import { ListItemSkeleton, SkeletonFade } from '@/shared/components/skeletons';

import List from '../VirtualizedList';

interface SkeletonListProps {
    listLength: number;
    minHeight?: string;
    maxHeight?: string;
    marginTop?: CSSProperties['marginTop'];
    avatars?: boolean;
    fade?: boolean;
}

const SkeletonList: FC<SkeletonListProps> = ({
    listLength,
    minHeight,
    maxHeight,
    marginTop,
    avatars = true,
    fade = false,
}): JSX.Element => {
    const data = Array.from({ length: listLength }).map((_, i) => ({
        id: i,
        title: '',
        description: '',
    }));

    const list = (
        <List
            style={{
                marginTop: marginTop ?? '1rem',
                minHeight: minHeight ? minHeight : '12rem',
                maxHeight: maxHeight ? maxHeight : '15rem',
                overflow: 'scroll',
            }}
            dataSource={data}
            renderItem={() => (
                <ListItemSkeleton
                    avatar={avatars}
                    avatarSize='default'
                    lineWidths={['82%', '56%']}
                    style={{
                        margin: '1rem 0',
                    }}
                />
            )}
        />
    );

    return fade ? <SkeletonFade>{list}</SkeletonFade> : list;
};

export default SkeletonList;
